import { actionTypes as types } from '../constants'

function sessionExpired(loginUrl) {
  return { type: types.SESSION_EXPIRED, loginUrl }
}

function requestBlocked(blockedActionType) {
  return { type: types.REQUEST_BLOCKED, blockedActionType }
}

function notFound() {
  return { type: types.NOT_FOUND }
}

function resetNotFound() {
  return { type: types.RESET_NOT_FOUND }
}

// TODO: To implement
function checkSession() {
  return { type: types.CHECK_SESSION }
}

function showLoadingSpinner() {
  return { type: types.SHOW_LOADING_SPINNER }
}

export { sessionExpired, requestBlocked, checkSession, notFound, resetNotFound, showLoadingSpinner }
